import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";

import {
  deliverySuccessMessage,
  toastErrorMessage,
} from "../../utils/toastMessage/toastMessage";
import { setAuthAction } from "../../redux/actions/authActions/authActions";

const BackToAdmin = () => {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);

  const isBackToAdmin = !!localStorage.getItem("adminToken");

  const handleBackToAdmin = () => {
    const accessToken = localStorage.getItem("adminToken");
    if (!accessToken) return toastErrorMessage("توکن ادمین یافت نشد");
    localStorage.removeItem("adminToken");
    dispatch(setAuthAction(accessToken));
    deliverySuccessMessage("شما با موفقیت وارد پنل مدیریت شدید", "/", "3000");
  };

  if (!isBackToAdmin || auth.isAdmin) return null;

  return (
    <button
      type="button"
      data-theme-toggle
      className="w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
      onClick={handleBackToAdmin}
    >
      <Icon icon="solar:login-broken" className="text-primary-light text-xl" />
    </button>
  );
};

export default BackToAdmin;
